import { useCallback, useEffect, useState } from 'react'
import { authApiService } from '../services/authApiService'

/**
 * A single-use nonce for Google's button, which takes it at render time. The API binds it to this
 * browser with a cookie and requires the ID token to echo it, so a replayed token is useless.
 * `renew` fetches a fresh one after each attempt (the API spends it either way).
 */
export function useOAuthNonce() {
  const [nonce, setNonce] = useState<string | null>(null)
  const renew = useCallback(() => {
    authApiService.oauthNonce().then(r => setNonce(r.nonce)).catch(() => setNonce(null))
  }, [])
  useEffect(() => { renew() }, [renew])
  return { nonce, renew }
}
